<template>
    <div class="billing-center-box">
        <van-nav-bar title="福利管理" />
        <div class="billing-center-content">
            <!-- // 暂时隐藏 -->
            <van-search
                v-model="paramas.boonName"
                show-action
                placeholder="请输入福利名称..."
                :clearable="false"
                @clear="onClear"
                @search="onSearch"
            >
                <template #action>
                    <div @click="onSearch">搜索</div>
                </template>
            </van-search>
            <div class="fuli">
                <div class="checkBox">
                    <div
                        :class="[{ active: index == activeIndex }, 'checkItem']"
                        v-for="(item, index) in checkList"
                        :key="index"
                        @click="changeBox(item, index)"
                    >
                        {{ item.text }}
                    </div>
                </div>
                <div class="coupon">
                    <div class="couponItem" v-for="(item, index) in couponList" :key="index">
                        <div class="sum">{{ item.sum }}</div>
                        <div>{{ item.text }}</div>
                    </div>
                </div>
            </div>
            <van-tabs @click="onClick" color="#fe7b43">
                <van-tab name="-1" title="全部"></van-tab>
                <van-tab name="1" title="领取中"></van-tab>
                <van-tab name="4" title="已领完"></van-tab>
                <van-tab name="5" title="已过期"></van-tab>
                <van-tab name="2" title="已下架"></van-tab>
            </van-tabs>
        </div>
        <ul class="welfare-voucher-list">
            <li class="welfare-voucher-item" v-for="(item, index) in welfareVoucherList" :key="index" @click="showOption(item)">
                <div class="item-status">
                    <div class="voucher-type">{{ item.type | filterate }}</div>
                    <div class="voucher-status">{{ item.putaway | flqstatus }}</div>
                </div>
                <div class="dashed-line"></div>
                <div class="item-info">
                    <div class="voucher-name">{{ item.boonName }}</div>
                    <div class="voucher-time">有效时限：{{ date }}</div>
                    <div class="voucher-num">
                        <span>{{ item.clickNum }}点击</span>
                        <span>{{ item.snappedNum }}/{{ item.total }}售出</span>
                        <span>{{ item.verificationNum }}核销</span>
                    </div>
                </div>
            </li>
        </ul>
        <van-action-sheet
            v-model="show"
            :actions="actions"
            @select="onSelect"
            cancel-text="取消"
            close-on-click-action
            @cancel="onCancel"
        />
    </div>
</template>

<script>
import { getMallBoonRoster } from '../api/index';
import moment from 'moment';
export default {
    data() {
        return {
            value: '',
            date: '',
            activeIndex: 0,
            show: false,
            detail: {},
            paramas: {
                boonName: '',
                phone: '',
                putaway: '-1',
                type: '-1'
            },
            checkList: [
                { text: '全部', type: '-1' },
                { text: '优惠券', type: '0' },
                { text: '现金券', type: '1' }
            ],
            couponList: [
                { text: '已发布福利券（份）', sum: 0 },
                { text: '已领取福利券（份）', sum: 0 },
                { text: '已核销福利券（份）', sum: 0 },
                { text: '本店已核销福利券（份）', sum: 0 }
            ],
            welfareVoucherList: [],
            actions: [
                { type: 'detail', name: '查看详情' },
                { type: 'list', name: '名单管理' }
            ]
        };
    },
    mounted() {
        this.paramas.phone = this.$globalData.phone1;
        this.getMallBoonRoster();
    },
    methods: {
        getMallBoonRoster() {
            getMallBoonRoster(this.paramas).then(res => {
                console.log(res.data);
                this.welfareVoucherList = res.data.data.mallBoonList;
                this.date =
                    moment(this.welfareVoucherList.indateStartTime).format('YYYY-MM-DD') +
                    '到' +
                    moment(this.welfareVoucherList.indateEndTime).format('YYYY-MM-DD');
                this.couponList[0].sum = res.data.data.total;
                this.couponList[1].sum = res.data.data.snappedNum;
                this.couponList[2].sum = res.data.data.verificationNum;
                this.couponList[3].sum = res.data.data.count;
            });
        },
        changeBox(e, index) {
            this.activeIndex = index;
            this.paramas.type = e.type;
            this.getMallBoonRoster();
        },
        onClick(name) {
            this.paramas.putaway = name;
            this.getMallBoonRoster();
        },
        onSearch() {
            console.log(this.paramas.boonName);
            this.getMallBoonRoster();
        },
        // 打开选项卡
        showOption(e) {
            this.detail = e;
            console.log(this.detail);
            this.show = true;
        },
        // 点击选项
        onSelect(item) {
            const path = item.type === 'detail' ? '/welfare-voucher-detail' : '/ListManagement';
            this.$router.push({ path, query: { id: this.detail.mallBoonID } });
            this.show = false;
        },
        onCancel() {
            this.show = false;
        },
        onClear() {
            this.paramas.boonName = '';
        }
    },
    filters: {
        filterate: function(value) {
            if (value === 1) return '待分配';
            if (value === 2) return '折扣券';
            if (value === 3) return '兑换券';
            if (value === 4) return '满减券';
            if (value === 5) return '现金券';
        },
        flqstatus: function(value) {
            if (value === 0) return '未上架';
            if (value === 1) return '上架中';
            if (value === 2) return '已下架';
            if (value === 3) return '抢购中';
            if (value === 4) return '已售馨';
            if (value === 5) return '已结束';
            if (value === 10) return '今日已抢完';
            if (value === 11) return '今日未开始';
            if (value === 12) return '今日已结束';
        }
    }
};
</script>

<style scoped lang="scss">
.billing-center-box {
    height: 100vh;
    background-color: #eeeeee;
    display: flex;
    flex-direction: column;

    .billing-center-content {
        .fuli {
            min-height: 200px;
            font-size: 16px;
            margin-bottom: 20px;
            .checkBox {
                display: flex;
                justify-content: space-between;
                padding: 20px 30px;
                color: #fff;
                .checkItem {
                    width: 80px;
                    height: 30px;
                    line-height: 30px;
                    border-radius: 15px;
                    text-align: center;
                    background-color: #64636396;
                }
                .active {
                    background: #fe7b43;
                }
            }
            .coupon {
                position: relative;
                display: flex;
                flex-wrap: wrap;
                margin: 0 10px;
                background-color: #fff;
                border-radius: 6px;
                .couponItem {
                    display: flex;
                    flex-direction: column;
                    justify-content: center;
                    align-items: center;
                    width: 50%;
                    height: 70px;
                    font-size: 14px;
                    .sum {
                        font-size: 26px;
                        color: #fe7b43;
                    }
                }
                .couponItem:nth-child(odd) {
                    // 单数添加
                    background-image: linear-gradient(to right, #c5c5c5 2px, transparent 2px); /* 使用渐变背景模拟边框 */
                    background-position: right; /* 将背景放置在右边 */
                    background-repeat: no-repeat; /* 防止背景图重复显示 */
                    background-size: 1px 50%; /* 设置背景图的高度为 div 高度的一半 */
                }
            }
        }
    }

    .welfare-voucher-list {
        margin: 10px;
        flex: 1;
        overflow: auto;

        .welfare-voucher-item {
            display: flex;
            background-color: #ffffff;
            border-radius: 6px;
            padding: 15px 20px;
            margin-bottom: 10px;

            .item-status {
                flex: 2;
                text-align: center;

                .voucher-type {
                    height: 20px;
                    background-image: linear-gradient(to right, rgb(253, 169, 169), #ff0000);
                    border-radius: 20px 6px 20px 6px;
                    font-style: italic;
                    line-height: 20px;
                    color: #ffffff;
                }

                .voucher-status {
                    color: #fe7b43;
                    font-weight: bold;
                    margin-top: 5px;
                }
            }
            .dashed-line {
                margin: 5px 20px;
                border-right: 2px dashed #b4b4b4;
            }
            .item-info {
                flex: 7;

                .voucher-name {
                    font-size: 16px;
                }

                .voucher-time {
                    line-height: 20px;
                    color: #a18600;
                }

                .voucher-num {
                    display: flex;
                    justify-content: space-between;
                    gap: 10px;
                    color: #a5a5a5;
                }
            }
        }
    }
}
</style>
